import { defineNuxtPlugin } from '#app/nuxt'
import { LazySvgoAquaCircuit, LazySvgoAquacircuit, LazySvgoArrowDownLarge, LazySvgoArrowDownXlarge, LazySvgoArrowDown, LazySvgoArrowLeft, LazySvgoArrowRight, LazySvgoArrowTop, LazySvgoBallet, LazySvgoBodyAttack, LazySvgoBodyBalance, LazySvgoBodyCombat, LazySvgoBodyJam, LazySvgoBodyPump, LazySvgoBodyStep, LazySvgoBodyattack, LazySvgoBodybalance, LazySvgoBodycombat, LazySvgoBodyjam, LazySvgoBodypump, LazySvgoBodystep, LazySvgoBodyvive, LazySvgoBootcamp, LazySvgoBornToMove, LazySvgoBorntomove, LazySvgoBtm, LazySvgoBurger, LazySvgoBurguer, LazySvgoChevronDown, LazySvgoChevronLeft, LazySvgoChevronRight, LazySvgoChevronUp, LazySvgoClose, LazySvgoCrossphit, LazySvgoCxWork, LazySvgoDuration, LazySvgoFlyoga, LazySvgoGap, LazySvgoGinasticaAcrobatica, LazySvgoGinasticaacrobatica, LazySvgoGritBootcamp, LazySvgoGritPlyo, LazySvgoGritStrength, LazySvgoGritbootcamp, LazySvgoGritplyo, LazySvgoGritstrength, LazySvgoHidroBike, LazySvgoHidroGinastica, LazySvgoHidroHiit, LazySvgoHidrobike, LazySvgoHidroginastica, LazySvgoHidrohiit, LazySvgoIntensity, LazySvgoKangoo, LazySvgoMobilidade, LazySvgoMusculacao, LazySvgoNatacaoBebes, LazySvgoNatacaoKids, LazySvgoNatacaobebes, LazySvgoNatacaokids, LazySvgoPhiveStretch, LazySvgoPhivestretch, LazySvgoPilates, LazySvgoPowerJump, LazySvgoPowerjump, LazySvgoRpm, LazySvgoSound, LazySvgoSpinning, LazySvgoStep, LazySvgoSwimCoach, LazySvgoSwimcoach, LazySvgoTrx, LazySvgoYoga, LazySvgoYoguitos, LazySvgoZumba } from '#components'
const lazyGlobalComponents = [
  ["SvgoAquaCircuit", LazySvgoAquaCircuit],
["SvgoAquacircuit", LazySvgoAquacircuit],
["SvgoArrowDownLarge", LazySvgoArrowDownLarge],
["SvgoArrowDownXlarge", LazySvgoArrowDownXlarge],
["SvgoArrowDown", LazySvgoArrowDown],
["SvgoArrowLeft", LazySvgoArrowLeft],
["SvgoArrowRight", LazySvgoArrowRight],
["SvgoArrowTop", LazySvgoArrowTop],
["SvgoBallet", LazySvgoBallet],
["SvgoBodyAttack", LazySvgoBodyAttack],
["SvgoBodyBalance", LazySvgoBodyBalance],
["SvgoBodyCombat", LazySvgoBodyCombat],
["SvgoBodyJam", LazySvgoBodyJam],
["SvgoBodyPump", LazySvgoBodyPump],
["SvgoBodyStep", LazySvgoBodyStep],
["SvgoBodyattack", LazySvgoBodyattack],
["SvgoBodybalance", LazySvgoBodybalance],
["SvgoBodycombat", LazySvgoBodycombat],
["SvgoBodyjam", LazySvgoBodyjam],
["SvgoBodypump", LazySvgoBodypump],
["SvgoBodystep", LazySvgoBodystep],
["SvgoBodyvive", LazySvgoBodyvive],
["SvgoBootcamp", LazySvgoBootcamp],
["SvgoBornToMove", LazySvgoBornToMove],
["SvgoBorntomove", LazySvgoBorntomove],
["SvgoBtm", LazySvgoBtm],
["SvgoBurger", LazySvgoBurger],
["SvgoBurguer", LazySvgoBurguer],
["SvgoChevronDown", LazySvgoChevronDown],
["SvgoChevronLeft", LazySvgoChevronLeft],
["SvgoChevronRight", LazySvgoChevronRight],
["SvgoChevronUp", LazySvgoChevronUp],
["SvgoClose", LazySvgoClose],
["SvgoCrossphit", LazySvgoCrossphit],
["SvgoCxWork", LazySvgoCxWork],
["SvgoDuration", LazySvgoDuration],
["SvgoFlyoga", LazySvgoFlyoga],
["SvgoGap", LazySvgoGap],
["SvgoGinasticaAcrobatica", LazySvgoGinasticaAcrobatica],
["SvgoGinasticaacrobatica", LazySvgoGinasticaacrobatica],
["SvgoGritBootcamp", LazySvgoGritBootcamp],
["SvgoGritPlyo", LazySvgoGritPlyo],
["SvgoGritStrength", LazySvgoGritStrength],
["SvgoGritbootcamp", LazySvgoGritbootcamp],
["SvgoGritplyo", LazySvgoGritplyo],
["SvgoGritstrength", LazySvgoGritstrength],
["SvgoHidroBike", LazySvgoHidroBike],
["SvgoHidroGinastica", LazySvgoHidroGinastica],
["SvgoHidroHiit", LazySvgoHidroHiit],
["SvgoHidrobike", LazySvgoHidrobike],
["SvgoHidroginastica", LazySvgoHidroginastica],
["SvgoHidrohiit", LazySvgoHidrohiit],
["SvgoIntensity", LazySvgoIntensity],
["SvgoKangoo", LazySvgoKangoo],
["SvgoMobilidade", LazySvgoMobilidade],
["SvgoMusculacao", LazySvgoMusculacao],
["SvgoNatacaoBebes", LazySvgoNatacaoBebes],
["SvgoNatacaoKids", LazySvgoNatacaoKids],
["SvgoNatacaobebes", LazySvgoNatacaobebes],
["SvgoNatacaokids", LazySvgoNatacaokids],
["SvgoPhiveStretch", LazySvgoPhiveStretch],
["SvgoPhivestretch", LazySvgoPhivestretch],
["SvgoPilates", LazySvgoPilates],
["SvgoPowerJump", LazySvgoPowerJump],
["SvgoPowerjump", LazySvgoPowerjump],
["SvgoRpm", LazySvgoRpm],
["SvgoSound", LazySvgoSound],
["SvgoSpinning", LazySvgoSpinning],
["SvgoStep", LazySvgoStep],
["SvgoSwimCoach", LazySvgoSwimCoach],
["SvgoSwimcoach", LazySvgoSwimcoach],
["SvgoTrx", LazySvgoTrx],
["SvgoYoga", LazySvgoYoga],
["SvgoYoguitos", LazySvgoYoguitos],
["SvgoZumba", LazySvgoZumba],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
